export class OrganizationIdpGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "idpId",
            "baseName": "idpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerGroupId",
            "baseName": "providerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleGrants",
            "baseName": "roleGrants",
            "type": "Array<OrganizationRoleGrant>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrganizationIdpGroup.attributeTypeMap;
    }
    constructor() {
    }
}
